import { memo, useState } from "react";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { GerAcesso } from "./GerAcesso";
import { useTranslation } from "react-i18next";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { useFormContext } from "@4uhub/lib4uhub";
import { useIServiceType } from "../useIServiceType";
import { useParams } from "react-router-dom";
import { IGerAcesso } from "../models";

interface IGerAcessoWrapperProps {
  iServiceTypes: IIServiceType[];
}

const GER_ACESSO_IMAGE = {
  src: "/iServices/ger-acesso.png",
  alt: "GerAcesso - TeletexSul",
};

const translationPath = "page.4uBus.register.iService.";

export const GerAcessoWrapper = memo(
  ({ iServiceTypes }: IGerAcessoWrapperProps) => {
    const { id } = useParams();

    const { t } = useTranslation();

    const { setValue, getValues } = useFormContext<TIServiceForm>();

    const { jsonParser, gerAcessoValues } = useIServiceType();

    const [isSelected, setIsSelected] = useState(() => {
      const gerAcesso = getValues("gerAcesso");
      return !!gerAcesso;
    });

    const saveConfigsJson = (v: TIServiceForm) => {
      const values = v.gerAcesso;
      if (!values) return;

      return values;
    };

    const handleConfirm = () => {
      const iServiceType = iServiceTypes.find(
        (iServiceType) => iServiceType.code === gerAcessoValues.code,
      );
      if (iServiceType) {
        setValue("iServiceType", iServiceType);
      }
      setIsSelected(true);
    };

    const handleClearConfigs = () => {
      setValue("configs", null);
      setValue("companyDigitalCertificate", null);
      setValue("iServiceType", null);
      setIsSelected(false);
    };

    const handleOpen = () => {
      setValue("gerAcesso", gerAcessoValues.defaultValues);
    };

    const handleCloseSelected = () => {
      const configs = getValues("configs");
      const gerAcessoValue = jsonParser<IGerAcesso>(configs);
      setValue("gerAcesso", gerAcessoValue);
    };

    const isEditingScreen = !!id;

    return (
      <IServiceType
        img={GER_ACESSO_IMAGE}
        renderComponent={({ namePrefix }) => (
          <GerAcesso namePrefix={namePrefix} />
        )}
        isSelected={isSelected}
        isEditingScreen={isEditingScreen}
        getFormattedData={saveConfigsJson}
        onConfirm={handleConfirm}
        onClearConfigs={handleClearConfigs}
        onOpen={handleOpen}
        onCloseSelected={handleCloseSelected}
        iServiceTypeName="gerAcesso"
        serviceName={t(translationPath + "ger_acesso")}
      />
    );
  },
);
